import { render } from "./CatalogSort.vue?vue&type=template&id=0a63bcae"
import script from "./CatalogSort.vue?vue&type=script&lang=js"
export * from "./CatalogSort.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__